export default __webpack_public_path__ + "fk-cp-zion/img/empty-cart-illustration_765111.jpg";